import {useState} from 'react'
import WizButton from '../../../../components/button/WizButton'
import UnderLineInput from '../../../../components/input/UnderLineInput'

interface IProps {
    className?: string
    onClick?: (e: string) => void
    input?: string
}

export const AddLeaderContainer: React.FC<IProps> = ({className, onClick, input}) => {
    const [inputText, setInputText] = useState('')
    return (
        <div className={`flex gap-[10px] w-full justify-end ${className}`}>
            <UnderLineInput
                type={'text'}
                inputClassName={'h-full'}
                value={input || inputText}
                onChanged={(e: string) => setInputText(e)}
                onEnterKeyPress={() => {
                    onClick(inputText)
                    setInputText('')
                }}
            />

            <WizButton
                text={'Add Leader'}
                size={'small'}
                onClick={() => {
                    onClick(inputText)
                }}
            />
        </div>
    )
}
